import { NavLink } from 'react-router-dom';
import type { PolicyArea } from '../types';

const MAIN_NAV = [
  { to: '/executive', label: 'Executive Summary' },
  { to: '/', label: 'Executive Dashboard' },
  { to: '/scenario-builder', label: 'Scenario Builder' },
  { to: '/projection-control', label: 'Projection Control' },
  { to: '/equilibrium', label: 'Policy Equilibrium' },
  { to: '/stochastic', label: 'Stochastic Macro' },
  { to: '/perception', label: 'Public Perception' },
  { to: '/decomposition', label: 'Growth Decomposition' },
  { to: '/verification', label: 'Verification Layer' },
  { to: '/vetting', label: 'Vetting & Progress' },
  { to: '/evidence', label: 'Data & Evidence' },
];

const GROWTH_NAV = [
  { to: '/model-overview', label: 'Model Overview' },
  { to: '/target-tracer', label: 'Target Tracer' },
  { to: '/chief-economist', label: 'Chief Economist' },
  { to: '/shocks', label: 'External Shocks' },
  { to: '/decisions', label: 'Decisions Taken' },
  { to: '/signature-programmes', label: 'Signature Programmes' },
  { to: '/workbook-model', label: 'Growth Model 2 (Workbook)' },
];

const PLATFORM_NAV = [
  { to: '/variables/new', label: 'Add Variable' },
  { to: '/linkage-builder', label: 'Linkage Builder' },
  { to: '/sub-model-builder', label: 'Sub-Model Builder' },
  { to: '/actions', label: 'Actions' },
  { to: '/model-library', label: 'Model Library' },
  { to: '/dependency-graph', label: 'Dependency Graph' },
  { to: '/interactions-lags', label: 'Interactions & Lags' },
  { to: '/macro-outcomes', label: 'Macro Outcomes' },
];

interface Props {
  areas: PolicyArea[];
  user?: { username: string } | null;
}

export function Sidebar({ areas, user }: Props) {
  return (
    <aside className="sidebar">
      <nav>
        {MAIN_NAV.map((item) => (
          <NavLink key={item.to} to={item.to} end={item.to === '/'}>
            {item.label}
          </NavLink>
        ))}
        <div style={{ margin: '1rem 0 0.5rem', padding: '0 1.25rem', fontSize: '0.65rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Growth Platform
        </div>
        {GROWTH_NAV.map((item) => (
          <NavLink key={item.to} to={item.to}>{item.label}</NavLink>
        ))}
        <div style={{ margin: '1rem 0 0.5rem', padding: '0 1.25rem', fontSize: '0.65rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Model Platform
        </div>
        {PLATFORM_NAV.map((item) => (
          <NavLink key={item.to} to={item.to}>{item.label}</NavLink>
        ))}
        <div style={{ margin: '1rem 0 0.5rem', padding: '0 1.25rem', fontSize: '0.65rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Policy Areas
        </div>
        {areas.map((a) => (
          <NavLink key={a.id} to={`/areas/${a.id}`} className="area-link" style={{ borderLeftColor: a.color }}>
            {a.name}
          </NavLink>
        ))}
        <div className="sidebar-bottom">
          <NavLink to="/model-equations">Model Equations & Rationale</NavLink>
          <NavLink to="/assumptions">Assumptions & Elasticities</NavLink>
          <NavLink to="/account">Account{user ? ` (${user.username})` : ''}</NavLink>
        </div>
      </nav>
    </aside>
  );
}
